import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Campaign } from '../../campaign.component';

@Component({
  selector: 'df-campaign-target-audience',
  templateUrl: './target-audience.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignTargetAudienceComponent {
  @Input() campaign!: Campaign;
}
